// extracted by mini-css-extract-plugin
module.exports = {"error-alert":"Error_error-alert__1piRq","error-title":"Error_error-title__9dnl4","error-button":"Error_error-button__14fHA"};